<template>
  <section class="main-content">
    <MainBanner banner="Jobs" />
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Startseite - ito consult GmbH",
        "item": "https://ito-consult.de"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Über uns",
        "item": "https://ito-consult.de/jobs"
      }]
    }
  </script>
    <section class="block-content py-5 mb-5 bg-grey">
        <div class="container my-md-5 py-md-5">
            <div class="content-midwide text-center" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">
                <article v-html="jobs_content"></article>
                <a href="#joboffers" @click="slidetoElement" class="btn btn-outline-ito hover-red animated-arrow mt-3 d-inline-flex align-items-center"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                  </svg>
                Finde deinen Traumjob!</a>
            </div>
        </div>
    </section>
    <section  class="block-content" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="0">
        <div class="container text-center my-md-5 py-5">
            <div id="benefits">
              <h2>Benefits</h2>
              <div class="row gx-5 pt-5">
                <div v-for="benefit in benefits"  :key="benefit.id" class="col-12 col-md-6 col-lg-4">
                  <img width="100" height="100" class="icon mb-4" :src="generateThumbnail(benefit.icon.data.asset_url,100,100,60,'contain')" :title="benefit.title" :alt="benefit.title" />
                  <h4>{{benefit.title}}</h4>
                  <article class="d-content" v-html="benefit.description"></article>
                </div>
              </div>
            </div>
        </div>
    </section>
    <section class="block-content border-start mb-5" id="joboffers">
      <div class="container my-5 py-5">
        <div class="content" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">
          <div v-for="job in jobs" :key="job.title" class="my-4 border-bottom">
            <div class="job d-lg-flex align-items-start">
              <article class="flex-fill">
                <h3>{{job.title}}</h3>
                <p v-html="jobDate(job.entry_date)"></p>
              </article>
              <router-link title="zur Stellenausschreibung" :to="{name: 'jobs.single', params: {id : job.slug}}" class="btn btn-outline-ito stretched-link hover-red animated-arrow mb-3 ">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"></path>
                </svg>
                {{job.button_text}}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
      <section  class="block-content" data-bg="grey" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="0">
        <div class="container text-center my-md-5 py-md-5">
            <blockquote class="py-5">Niemand weiß, was er kann, bevor er's versucht.
                <span class="author mt-3 d-block">Publilius Syrus</span>
            </blockquote>
        </div>
    </section>
    <section class="block-content">
      <div class="container my-md-5 py-md-5">
        <div class="row my-5 py-5 align-items-center" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">
          <div class="col-12 col-md-5 mb-4 mb-md-0">
            <div class="img-container">
              <img width="540" height="540" class="img-fluid" :src="generateThumbnail(jobs_image.data.asset_url,540,540,60,'contain')" title="Worauf wartest du" alt="ito Team" />
            </div>
          </div>
          <div class="col-12 col-md-6 offset-md-1">
            <article v-html="jobs_wait"></article>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>

import axios from 'axios'
import store from '@/store'
const MainBanner = () => import('@/components/Content/MainBanner.vue')

export default {
  name: 'Jobs',
  metaInfo () {
    return {
      title: this.$parent.getMetaTitle('Jobs'),
      meta: [
        { name: 'description', content: this.$parent.getDescription('Jobs') },
        { property: 'og:title', content: this.$parent.getOGTitle('Jobs') },
        { property: 'og:description', content: this.$parent.getOGDescription('Jobs') }
      ]
    }
  },
  data: function () {
    return {
      jobs: {},
      benefits: {}
    }
  },
  methods: {
    slidetoElement: function (e) {
      e.preventDefault()
      const scrollToEl = document.querySelector(e.target.attributes.href.nodeValue) !== null
      if (scrollToEl) {
        document.querySelector(e.target.attributes.href.nodeValue).scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    jobDate: function (d) {
      const today = new Date()
      const jobentry = new Date(d)

      return today > jobentry ? 'ab sofort' : ('0' + jobentry.getDate()).slice(-2) + '.' + ('0' + (jobentry.getMonth() + 1)).slice(-2) + '.' + jobentry.getFullYear()
    },
    generateThumbnail (asset, w, h, q, f) {
      return 'https://cdn.ito-consult.de' + asset + '?w=' + w + '&h=' + h + '&q=' + q + '&f=' + f
    }
  },
  async beforeMount () {
    await axios.get('/jobs')
      .then(response => {
        this.jobs = response.data.data
        store.commit('loadingStatus', false)
      })
    await axios.get('/benefits?fields=*.*')
      .then(response => (this.benefits = response.data.data))
  },
  components: {
    MainBanner
  },
  computed: {
    jobs_content () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter(item => {
          return item.title.indexOf('Jobs-Einleitung') > -1
        })
        return txt.length ? txt[0].content : ''
      } else {
        return ''
      }
    },
    jobs_wait () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter(item => {
          return item.title.indexOf('Jobs-Worauf-Warten') > -1
        })
        return txt.length ? txt[0].content : ''
      } else {
        return ''
      }
    },
    jobs_image () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter(item => {
          return item.title.indexOf('Jobs-Worauf-Warten') > -1
        })
        return txt.length ? txt[0].image : ''
      } else {
        return ''
      }
    }
  }

}
</script>

<style>
  #benefits .row {font-size: 1rem;}
  #joboffers h3 {color: var(--ito-red); font-weight: 100; font-family: 'Merriweather', sans-serif;  font-size: 1.4rem; line-height: 1.5;}
  #benefits h4 {color: #333; font-weight: 100; font-family: 'Merriweather', sans-serif;  font-size: 1.1rem;}
  #benefits article {text-align: left;}
  .job {position: relative;}
  .icon {max-width: 100px;}
</style>
